/**
 * Calculation utilities for PhieuKeToan (Accounting Voucher)
 * Handles foreign currency amount calculations for display purposes
 */

export interface PhieuKeToanTotals {
  t_ps_no_nt: number;
  t_ps_co_nt: number;
  t_ps_no: number;
  t_ps_co: number;
}

/**
 * Calculate totals from detail rows for display in BottomActionBarV2
 * @param detailRows - Array of detail row data
 * @returns Calculated totals for display
 */
export const calculateTotals = (detailRows: any[] = []): PhieuKeToanTotals => {
  const t_ps_no_nt = detailRows.reduce(
    (sum: number, row: { ps_no_nt: string | number }) => sum + (parseFloat(row.ps_no_nt as string) || 0),
    0
  );

  const t_ps_co_nt = detailRows.reduce(
    (sum: number, row: { ps_co_nt: string | number }) => sum + (parseFloat(row.ps_co_nt as string) || 0),
    0
  );

  const t_ps_no = detailRows.reduce(
    (sum: number, row: { ps_no: string | number }) => sum + (parseFloat(row.ps_no as string) || 0),
    0
  );

  const t_ps_co = detailRows.reduce(
    (sum: number, row: { ps_co: string | number }) => sum + (parseFloat(row.ps_co as string) || 0),
    0
  );

  return {
    t_ps_no_nt,
    t_ps_co_nt,
    t_ps_no,
    t_ps_co
  };
};
